import {AssistantTypeModel, AssistantVoiceGenderModel} from "./assistants";
import {ListModel} from "./common";

export enum AgentTemplatePriceTagModel {
  FREE = "free",
  PAID = "paid",
}

export enum AgentTemplateIndustryTypeModel {
  REAL_ESTATE = "Real Estate",
  HEALTHCARE = "Healthcare",
  SOLAR = "Solar",
  RECRUITMENT = "Recruitment",
  CAR_DEALERSHIP = "Car Dealership",
  MORTGAGE = "Mortgage",
  HOSPITALITY = "Hospitality",
  INSURANCE = "Insurance",
  EDUCATION = "Education",
  RETAIL = "Retail",
}

export enum AgentTemplateIncludedActionModel {
  GET_USER_ADDRESS = "getUserAddress",
  GET_USER_PREFERENCES = "getUserPreferences",
  LOG_INTERACTION = "logInteraction",
  SHOWED_INTEREST = "showedInterest",
  WAS_BUSY = "wasBusy",
  DND_ACTIVATED = "dndActivated",
  CALLBACK_REQUESTED = "callbackRequested",
  USER_EMAIL = "userEmail",
  USER_NAME = "userName",
  APPOINTMENTS_FOR_DATE = "appointmentsForDate",
  NOT_SPECIFIED = "notSpecified",
  NOT_BOOKED = "notBooked",
  USER_INTEREST_LEVEL = "userInterestLevel",
}

export interface TemplateActionRecordModel {
  actionId: string;
  actionType: string;
  name: string;
}

export type TemplateActionListModel = TemplateActionRecordModel[];

export type TemplateRecordModel = {
  id: string;
  name: string;
  agentType: AssistantTypeModel;
  description: string;
  imageUrl: string;
  industry: AgentTemplateIndustryTypeModel | null;
  language: string;
  numberOfDownloads: number;
  priceCost: number;
  priceTag: AgentTemplatePriceTagModel;
  tags: string[];
  voiceGender: AssistantVoiceGenderModel;
  voiceSampleUrl: string;
  actions: TemplateActionListModel;
};

export type TemplateListModel = ListModel<TemplateRecordModel>;

export type TemplateCompactModel = Pick<TemplateRecordModel, "id" | "name">;

export type TemplateCompactListModel = ListModel<TemplateCompactModel>;

export type TemplateDetailedModel = TemplateRecordModel;
